import React from 'react';
import PropTypes from 'prop-types';
import Reveal from '../../reveal';
import SectionTitle from '../../home/home-section-title';
import SectionMessage from '../../home/home-section-message';
import HomeServicesCards from './home-services-cards';
import styles from './home-services.module.css';

const HomeServices = ({ services }) => {
  const settings = {
    sectionTitle: 'Our Capabilities',
    sectionMessage: `Need big-picture strategy? Or one shareable video?<span style="display: block;"></span>
    We're ready to build a strong partnership with you&mdash; one great project at a time.
    `,
  };

  const servicesWithMultiplier = services.map((service, index) => {
    return { ...service, multiplier: 250 * (index + 1) };
  });

  return (
    <React.Fragment>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <Reveal>
            <SectionTitle sectionName={settings.sectionTitle} white={true} />
            <SectionMessage
              sectionMessage={settings.sectionMessage}
              white={true}
            />
          </Reveal>
          <Reveal>
            <HomeServicesCards
              servicesWithMultiplier={servicesWithMultiplier}
            />
          </Reveal>
        </div>
      </div>
    </React.Fragment>
  );
};

HomeServices.propTypes = {
  services: PropTypes.array,
};

export default HomeServices;



// WEBPACK FOOTER //
// ./src/components/home/home-services/index.js